import { BlockConfigurationObject } from "../interfaces/block-configuration-object.interface";
import { MatchBet } from "../interfaces/match-bet.interface";
import { Match } from "../interfaces/match.interface";
import { GeneralService } from "./general.service";

export class BetService {
	_configurationObject: BlockConfigurationObject;
	_generalService: GeneralService;

	/* @ngInject */
	constructor(configurationObject: BlockConfigurationObject, generalService: GeneralService) {
		this._configurationObject = configurationObject;
		this._generalService = generalService;
	}

	populateTileBettingInfo(match: Match): void {

		// single bookmaker configuration
		if ((this._configurationObject.oddsProvider || this._configurationObject.bookmakerTheme)
			&& !(this._configurationObject.bookmakerThemeSportExceptions
				&& this._configurationObject.bookmakerThemeSportExceptions.includes(match.MatchData.Sport))) {

			let oddsProvider: string;
			if (this._configurationObject.sportExclusiveBookmakers && Object.keys(this._configurationObject.sportExclusiveBookmakers).includes(match.MatchData.Sport.toUpperCase())) {
				oddsProvider = this._configurationObject.sportExclusiveBookmakers[match.MatchData.Sport.toUpperCase()];
			} else {
				oddsProvider = this._configurationObject.oddsProvider || this._configurationObject.bookmakerTheme;
			}
			if (Object.keys(match.BettingData).includes(oddsProvider)) {
				match.aggregatedBettingInfo = match.BettingData[oddsProvider];
				match.aggregatedBettingInfo.h2hHomeProvider = this._configurationObject.bookmakerTheme || "";
				match.aggregatedBettingInfo.h2hAwayProvider = this._configurationObject.bookmakerTheme || "";
				match.aggregatedBettingInfo.lineHomeProvider = this._configurationObject.bookmakerTheme || "";
				match.aggregatedBettingInfo.lineAwayProvider = this._configurationObject.bookmakerTheme || "";
				match.aggregatedBettingInfo.totalOverProvider = this._configurationObject.bookmakerTheme || "";
				match.aggregatedBettingInfo.totalUnderProvider = this._configurationObject.bookmakerTheme || "";
			} else {
				match.bettingInfoUnavailable = true;
			}
		}

		if (["mlb", "nhl", "bbl"].includes(match.MatchData.Sport.toLowerCase()) || this._generalService.isSoccer(match.MatchData.Sport)) {
			if (!match.aggregatedBettingInfo || !match.aggregatedBettingInfo.HomeOdds || !match.aggregatedBettingInfo.AwayOdds) {
				match.bettingInfoUnavailable = true;
			}
		} else if (match.MatchData.Sport.toLowerCase() === "ten") {
			if (!match.aggregatedBettingInfo || !match.aggregatedBettingInfo.H2HOdds || !match.aggregatedBettingInfo.H2HOdds.player1 || !match.aggregatedBettingInfo.H2HOdds.player2) {
				match.bettingInfoUnavailable = true;
			}
		} else {
			if (!match.aggregatedBettingInfo || !match.aggregatedBettingInfo.HomeLine || !match.aggregatedBettingInfo.HomeLineWinPct || !match.aggregatedBettingInfo.AwayLineWinPct) {
				match.bettingInfoUnavailable = true;
			}
		}
	}

	bestBetName(bet: MatchBet, sport: string): string {
		if (bet.type === "h2h") {
			return "Moneyline";
		}
		if (bet.type === "firstset") {
			return "First Set";
		}
		if (bet.type === "total") {
			return "Over/Under";
		}
		if (bet.type === "bts") {
			return "Both Teams to Score";
		}
		if (bet.type === "line") {
			if (sport.toLowerCase() === "mlb") {
				return "Run Line";
			}
			if (sport.toLowerCase() === "nhl") {
				return "Puck Line";
			}
			
			return "Spread";
		}
		if (bet.type === "high-open") {
			return "Highest Opening Partnership";
		}
		if (bet.type === "four-overs") {
			return "After 4 Overs";
		}
		if (bet.type === "first-wicket") {
			return "First Wicket";
		}
		if (bet.type === "most-sixes") {
			return "Most Sixes";
		}

		return "";
	}

	valueFireOpacity(edge: number): number {
		// if (edge < 0) {
		// 	return 0;
		// }

		// if (edge >= 10) {
		// 	return 1;
		// }

		// return 0.2 + edge * 0.08;

		if (edge < 4) {
			return 0;
		}

		return 1;
	}

	bookmakerLink(bookieCode: string, deepLinkOptions?: Record<string, any>): string {
		if (deepLinkOptions && this._configurationObject.useDeepBookmakerLinks) {
			// if (bookieCode === "bet365"
			// 	&& this._configurationObject.bookmakerAffiliateCodes
			// 	&& Object.keys(this._configurationObject.bookmakerAffiliateCodes).includes("bet365")) {
			// 	return `http://www.bet365.com/betslip/instantbet/default.aspx?fid=${deepLinkOptions.FID}`
			// 		+ `&participantid=${deepLinkOptions.ID}`
			// 		+ `&affiliatecode=${this._configurationObject.bookmakerAffiliateCodes.bet365}`
			// 		+ `&odds=${deepLinkOptions.Odds}&Instantbet=1&AVG=${deepLinkOptions.AVG}`;
			// }

			if (bookieCode === "betfair") {
				return deepLinkOptions.URL;
			}

			// TODO support for deep links from other bookmakers
		}
		if (this._configurationObject.customBookmakerLinks && Object.keys(this._configurationObject.customBookmakerLinks).includes(bookieCode)) {
			return this._configurationObject.customBookmakerLinks[bookieCode];
		}

		// TODO should we return a generic link that matches the bookie code and just goes to their home page?
		return "";
	}
	
	stylisedBookName(bookieCode: string): string {
		if (bookieCode === "fanduel") return "FanDuel";
		if (bookieCode === "sugarhouse") return "SugarHouse";
		if (bookieCode === "pointsbet") return "PointsBet";
		if (bookieCode === "william_hill") return "Caesars";
		if (bookieCode === "draftkings") return "DraftKings";
		if (bookieCode === "wynn") return "WynnBET";
		if (bookieCode === "betway") return "Betway";
		if (bookieCode === "tipico") return "Tipico";
		if (bookieCode === "unibet") return "Unibet";
		if (bookieCode === "bet365") return "Bet365";
		if (bookieCode === "betmgm") return "BetMGM";
		if (["bet_rivers_in", "bet_rivers_va", "bet_rivers_co"].includes(bookieCode)) return "BetRivers";

		// TODO more bookies
		return "";
	}

	formatOdds(decimalOdds: number): string {
		if (decimalOdds && this._configurationObject.oddsDisplayFormat === "decimal") {
			return decimalOdds.toFixed(2);
		}

		if (this._configurationObject.oddsDisplayFormat === "american") {
			if (decimalOdds < 2) {
				const minusNumber = 100 / (decimalOdds - 1);
				return "-" + minusNumber.toFixed(0);
			}

			const plusNumber = (decimalOdds * 100) - 100;
			return "+" + plusNumber.toFixed(0);
		}

		// TODO fractional
		return "";
	}

}